export default __webpack_public_path__ + "static/media/condition.cd8280fa.svg";